import { StyleSheet } from 'react-native';
import styled, { css } from 'styled-components/native';

import { neutralWhite, warrior } from '../../constants/color';

const TITLE_LINE_HEIGHT = 25;

export const LIST_GAP = 15;

const titleBaseStyle = css`
  font-size: 18px;
  color: ${warrior};
  margin-left: 15px;
  font-weight: 700;
  line-height: ${TITLE_LINE_HEIGHT}px;
`;

export const S = {
  SpecialForYouTitle: styled.Text`
    ${titleBaseStyle};
    padding-top: 20px;
    padding-bottom: 10px;
  `,
};

const styles = StyleSheet.create({
  listColumnWrapperStyle: {
    flexWrap: 'wrap',
  },
  noMoreItemsView: {
    backgroundColor: neutralWhite,
  },
  listItem: {
    marginTop: 0,
    marginBottom: 10,
  },
  listLeftItem: {
    marginLeft: 15,
    marginTop: 0,
    marginBottom: 10,
  },
  listRightItem: {
    marginRight: 15,
    marginTop: 0,
    marginBottom: 10,
  },
});

export default styles;
